export const Environment = {
  AngularProduction: true,
  WebSoketURL: "", //ws://test.aeroguest.io:39285
  WebsocketGateUser: "", //ws://test.aeroguest.io:39286
  WebsocketGateAdmin: "", //ws://test.aeroguest.io:39285
  WebsocketGateCommunication: "ws://test.aeroguest.io:39245/chatHub",
  BlobStorageUrl: "https://aeroguestdev.blob.core.windows.net",
  RegistrationCardLogoGuid: "8e2f5f3e-2f4b-4d3a-9f4e-1c2b3a4d5e6f",
  isProduction: false,
  imageFrontDoorUrl: "https://route-imgtransform-dev-b3fec2a3e9ceekeu.a03.azurefd.net",
}
